//remove empty headings
document.querySelectorAll('h2, h3, h4, h5, h6').forEach(function(heading) {
    if (!heading.textContent.trim()) {
        heading.remove();
    }
});

//br tag fix
$(document).ready(function() {
    $('br').attr('aria-hidden','true');

});

// tabs on product page
document.querySelectorAll('.swatches--hld span').forEach(function(span) {
    span.setAttribute('role', 'tab');
    if (span.classList.contains('swatch--active')) {
        span.setAttribute('aria-selected', 'true');
    } else {
        span.setAttribute('aria-selected', 'false');
    }
    span.addEventListener('click', function() {
        document.querySelectorAll('.swatches--hld span').forEach(function(item) {
            item.setAttribute('aria-selected', 'false');
            item.classList.remove('swatch--active'); // Remove active class
        });
        this.setAttribute('aria-selected', 'true');
        this.classList.add('swatch--active');
    });
});


//blogs read more warnings 
document.addEventListener('DOMContentLoaded', function() {
    // Iterate over all anchor tags with the specified href
    document.querySelectorAll('a[href="/blogs/news/how-to-store-watches"],a[href="/blogs/news/holiday-gifts-for-watch-lovers"],a[href="/blogs/news/how-to-clean-watch-strap"],a[href="/blogs/news/how-to-pick-the-right-watch-for-a-gift"],a[href="/blogs/news/can-men-wear-women-watches"],a[href="/blogs/news/types-of-womens-watches"],a[href="/blogs/news/leather-strap-vs-metal-strap-watches"],a[href="/blogs/news/best-watches-for-travel"],a[href="/blogs/news/what-is-a-sports-watch"],a[href="/blogs/news/types-watch-dials"],a[href="/blogs/news/types-of-mens-watches"],a[href="/blogs/news/what-age-should-a-kid-get-a-watch"],a[href="/blogs/news/watch-sizes-guide"],a[href="/blogs/news/smartwatch-benefits"],a[href="/blogs/news/what-is-a-smartwatch"],a[href="/blogs/news/can-women-wear-men-watches"],a[href="/blogs/news/types-of-watch-straps"],a[href="/blogs/news/how-long-do-watch-batteries-last"],a[href="/blogs/news/what-hand-do-you-wear-a-watch-on"],a[href="/blogs/news/analog-vs-digital-watches"],a[href="/blogs/news/automatic-vs-quartz-watches"],a[href="/blogs/news/what-is-an-analog-watch"],a[href="/blogs/news/what-is-an-automatic-watch"],a[href="/blogs/news/types-of-watches"],a[href="/blogs/news/what-is-a-chronograph-watch"],a[href="/blogs/news/how-to-wear-a-watch"],a[href="/blogs/news/parts-of-a-watch"],a[href="/blogs/news/how-to-clean-a-watch"],a[href="/blogs/news/how-to-change-watch-battery"],a[href="/blogs/news/how-does-a-watch-work"],a[href="/blogs/news/5-fun-facts-about-watches"]').forEach(function(link) {
        var originalTitle = link.textContent.trim();
        var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '...' : originalTitle;
        var ariaLabelText = trimmedTitle;

        // Check if the link is inside a specific container with an h2
        var closestDiv = link.closest('div');
        var h2 = closestDiv ? closestDiv.querySelector('h2') : null;
        if (h2) {
            var h2Text = h2.textContent.trim();
            ariaLabelText = trimmedTitle + ' about ' + h2Text ;
        }

        // Update the aria-label attribute and remove the title attribute
        link.setAttribute('aria-label', ariaLabelText);
        link.removeAttribute('title');
    });
});


//slideshow fix
$(document).ready(function () {
    function updateAriaHidden() {
      $('[data-bstr-slide="active"]').each(function () {
        if ($(this).attr('aria-hidden') === 'true') {
          $(this).removeAttr('aria-hidden');
        }
      });
      $('[data-bstr-slide]:not([data-bstr-slide="active"])').each(function () {
        if (!$(this).attr('aria-hidden')) {
          $(this).attr('aria-hidden', 'true');
        }
      });
    }
    updateAriaHidden();
    setInterval(function () {
      updateAriaHidden();
    }, 500); 
    $(document).on('slideChangeEvent', function () {
      updateAriaHidden();
    });
  });
  

//product accordion
$(document).ready(function() {
    $('.accordion__desc').attr('aria-hidden','true');
});
document.querySelectorAll('.accordion__title').forEach((button) => {
    button.addEventListener('click', () => {
      const content = button.nextElementSibling; // The corresponding content div
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !isExpanded); // true -> false, false -> true
      content.setAttribute('aria-hidden', isExpanded);  // true -> false, false -> true
      content.style.display = isExpanded ? 'none' : 'block';
    });
});


// account expand/collaps
$(document).ready(function () {
    $('.account-btn').on('click', function () {
        const isExpanded = $(this).attr('aria-expanded') === 'true';

        // Toggle aria-expanded on the button
        $(this).attr('aria-expanded', !isExpanded);

        // Toggle aria-hidden on the user__holder
        $('.user__holder').attr('aria-hidden', isExpanded);
    });
});


// search hidden content solution
$(document).ready(function () {
  $('.search__icon.search--desktop').on('click', function () {
      const searchContainer = $('.search__container--abs');
      const isHidden = searchContainer.attr('aria-hidden') === 'true';

      // Toggle aria-hidden on the search container
      searchContainer.attr('aria-hidden', !isHidden);
  });
});
// focus redirect search
$(document).ready(function () {
  $('#close-btn').on('click', function () {
      $('.search__container--abs').attr('aria-hidden', 'true');
      setTimeout(function () {
          $('.search__icon.search--desktop').focus();
      }, 1000); 
  });
});
//search esacpe closure
$(document).ready(function () {
  $('.search__container--abs').on('keydown', function (e) {
    if (e.key === "Escape") {
      $(this).removeClass('focused');
      $(this).attr('aria-hidden','true');
      $('.search__icon.search--desktop').focus();
    }
  });
});


// on-click dropdown 
document.addEventListener('DOMContentLoaded', function () {
    const dropdownToggles = document.querySelectorAll('.js-click-hover .nav__link');
    let lastFocusedToggle = null; // Store the last focused toggle button

    function closeAllDropdowns(exceptToggle = null) {
        dropdownToggles.forEach(toggle => {
            const dropdownMenu = toggle.nextElementSibling;
            if (toggle !== exceptToggle) {
                toggle.setAttribute('aria-expanded', 'false');
                dropdownMenu.style.display = 'none';
            }
        });
    }

    dropdownToggles.forEach(toggle => {
        const dropdownMenu = toggle.nextElementSibling;

        const closeDropdown = () => {
            toggle.setAttribute('aria-expanded', 'false');
            dropdownMenu.style.display = 'none';

            // Return focus to the last focused toggle after 500ms
            if (lastFocusedToggle) {
                setTimeout(() => {
                    lastFocusedToggle.focus();
                }, 100);
            }
        };

        const openDropdown = () => {
            closeAllDropdowns(toggle); // Close other dropdowns before opening this one
            toggle.setAttribute('aria-expanded', 'true');
            dropdownMenu.style.display = 'flex';
            lastFocusedToggle = toggle; // Store the focused button
        };

        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeDropdown();
            } else {
                openDropdown();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
                closeDropdown();
            }
        });

        dropdownMenu.addEventListener('focusout', function (e) {
            if (!dropdownMenu.contains(e.relatedTarget) && !toggle.contains(e.relatedTarget)) {
                closeDropdown();
            }
        });
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.js-click-hover')) {
            closeAllDropdowns();
        }
    });
});

//slider
$(document).ready(function () {
  $('.products-slider__slider__item.swiper-slide.card--holder.s__block').each(function (index) {
      $(this).attr('id', 'slide-' + (index + 1));
  });
});
$(document).ready(function() {
  var currentSlide = 1;
  var totalSlides = $('.products-slider__slider__item').length;

  // Function to update aria-hidden for slides
  function updateSlides() {
      // Reset all slides to aria-hidden="true"
      $('.products-slider__slider__item').attr('aria-hidden', 'true');
      
      // Show first 4 slides (aria-hidden="false")
      for (var i = currentSlide; i < currentSlide + 4 && i <= totalSlides; i++) {
          var slideId = '#slide-' + i;
          $(slideId).attr('aria-hidden', 'false');
      }

      // If there are fewer than 4 slides remaining, adjust the last slide shown
      if (currentSlide + 4 > totalSlides) {

          var lastSlideId = '#slide-' + totalSlides;
          $(lastSlideId).attr('aria-hidden', 'false');
      }
  }

  // Handle "next" button click
  $('.js-swiper-btn-next').click(function() {
      if (currentSlide + 4 <= totalSlides) {
          currentSlide++;
      } else {
          currentSlide = 1; // Loop back to first slide
      }
      updateSlides();
  });

  // Handle "previous" button click
  $('.js-swiper-btn-prev').click(function() {
      if (currentSlide > 1) {
          currentSlide--;
      } else {
          currentSlide = totalSlides - 3; // Loop back to the last set of slides
      }
      updateSlides();
  });

  // Initial update when page loads
  updateSlides();
});

//h2 to p
$(document).ready(function() {
  $(".slide__content.start.layout__content h2").replaceWith(function() {
      return $("<p>", {
          class: $(this).attr("class"),
          html: $(this).html()
      });
  });
});

// accordion tabs
$(document).ready(function () {
    $(".accordion__item--title").on("click", function () {
        let $this = $(this);
        let $content = $this.next(".accordion__item--content");
        let isExpanded = $this.attr("aria-expanded") === "true";

        // Close all other accordions
        $(".accordion__item--title").attr("aria-expanded", "false");
        $(".accordion__item--content").slideUp(200);

        // If the clicked accordion was previously closed, open it
        if (!isExpanded) {
            $this.attr("aria-expanded", "true");
            $content.slideDown(200);
        }
    });
});

//email warnings
$(document).ready(function() {
    $('a[href="mailto:servicedept@egluck.com"],a[href="mailto:servicedept@egluck.com"],a[href="mailto:clarity@egc-clarity.com"],a[href="mailto:ejloewen@msn.com"]' ).each(function() {
        var originalTitle = $(this).text();
           var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
      $(this).attr('aria-label', 'Email Address: ' + trimmedTitle + ' (open in a new window)');
      $(this).attr('target', '_blank');
      $(this).removeAttr('title');
    });
});

//external links warnings
const anchors = document.querySelectorAll('a[href="https://www.prnewswire.com/news-releases/armitron-launches-armitron-connect-smartwatches-catapulting-legacy-watch-brand-into-a-new-era-of-smartwatch-innovation-302233504.html"],a[href="https://www.google.com/maps/dir//Armitron,+60-15+Little+Neck+Pkwy,+Little+Neck,+NY+11362/@40.7596893,-73.7237542,17z/data=!4m16!1m7!3m6!1s0x4065fce7c1fa4027:0xe38ec1d25524fdc9!2sArmitron!3b1!8m2!3d40.7596504!4d-73.7215822!4m7!1m0!1m5!1m1!1s0x4065fce7c1fa4027:0xe38ec1d25524fdc9!2m2!1d-73.7215822!2d40.7596504"],a[href="https://www.google.com/maps/dir//5010+NE+99th+St,+Vancouver,+WA+98665,+USA/@45.693503,-122.6220867,17z/data=!4m16!1m7!3m6!1s0x5495ae17d54e5285:0x8927465dc9241d4a!2s5010+NE+99th+St,+Vancouver,+WA+98665,+USA!3b1!8m2!3d45.693503!4d-122.619898!4m7!1m0!1m5!1m1!1s0x5495ae17d54e5285:0x8927465dc9241d4a!2m2!1d-122.619898!2d45.693503"],a[href="https://www.google.com/maps/dir//The+Time+Machine,+2335+Honolulu+Ave,+Montrose,+CA+91020,+USA/@34.2062317,-118.2316041,17z/data=!4m16!1m7!3m6!1s0x80c2ea6d34803b89:0xe068202e7e137e15!2sThe+Time+Machine!3b1!8m2!3d34.2062373!4d-118.2294341!4m7!1m0!1m5!1m1!1s0x80c2ea6d34803b89:0xe068202e7e137e15!2m2!1d-118.2294341!2d34.2062373"],a[href="https://www.google.com/maps/dir//Armitron,+27326+Grand+River+Ave,+Redford+Charter+Twp,+MI+48240/@42.440342,-83.3182327,17z/data=!4m16!1m7!3m6!1s0x8824b6a23d4d7515:0xf6287ba9ca0910f!2sArmitron!3b1!8m2!3d42.440342!4d-83.3160439!4m7!1m0!1m5!1m1!1s0x8824b6a23d4d7515:0xf6287ba9ca0910f!2m2!1d-83.3160439!2d42.440342"],a[href="https://www.google.com/maps/dir//Louis-Neil+Watchmakers,+9831+Bustleton+Ave+%235,+Philadelphia,+PA+19115/@40.0906841,-75.0345163,17z/data=!4m16!1m7!3m6!1s0x89c6b3b985084aa1:0x2d5807fa8c0dafb6!2sLouis-Neil+Watchmakers!3b1!8m2!3d40.090652!4d-75.032445!4m7!1m0!1m5!1m1!1s0x89c6b3b985084aa1:0x2d5807fa8c0dafb6!2m2!1d-75.032445!2d40.090652"],a[href="https://www.google.com/maps/dir//Circe+International+Ltd,+Sing+Mei+Industrial+Building+29-37+Kwai+Wing+Road+Kwai+Chung+NT,+Hong+Kong/@22.3671602,114.0988696,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x3403f89a5c770443:0x7ce878bee806f749!2m2!1d114.133889!2d22.367164"],a[href="http://support@armitron.zendesk.com/"],a[href="https://armitron.zendesk.com/hc/en-us/requests/new"],a[href="http://www.shareasale.com/join/armitron"],a[href="https://armitronconnect.com/"]');
anchors.forEach(anchor => {
    const trimmedText = anchor.textContent.trim();
    anchor.setAttribute('aria-label', `${trimmedText} (opens in a new window)`);
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
});

//phone number warnings
$(document).ready(function() {
    $('a[href="tel:+18666310342"],a[href="tel:+17184824195"], a[href="tel:+17187840700"],a[href="tel:+13605737225"],a[href="tel:+13605765874"],a[href="tel:+18182496007"],a[href="tel:+18182499412"],a[href="tel:+13135340736"],a[href="tel:+13135340737"],a[href="tel:+12156763729"],a[href="tel:85224242211"]').each(function() {
        var originalTitle = $(this).text();
        
        var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
        
        // Add "email address" before the trimmedTitle in the aria-label
        $(this).attr('aria-label', 'Phone Number: ' + trimmedTitle + ' (open in a new window)');
        
        $(this).attr('target', '_blank');
        $(this).removeAttr('title');
    });
  });

  $(document).ready(function () {
    setTimeout(() => {
        $(".filter__toggle").click(function () {
            let isExpanded = $(this).attr("aria-expanded") === "true";
            $(this).attr("aria-expanded", isExpanded ? "false" : "true");
        });
    }, 200);
});

// tab issue
$(document).ready(function () {
    $("[role='button']").each(function () {
        if (!$(this).attr("tabindex")) {
            $(this).attr("tabindex", "0"); 
        }
    });

    $(document).on("keydown", "[role='button']", function (event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault(); 
            $(this).trigger("click"); 
        }
    });
});